import { Component, OnChanges } from '@angular/core';
import { CustomerManageService } from '../shared/customer-manage.service';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerAffiliationType } from '../models/enums/customer-affiliation-type.enum';
import { CustomerAffiliation } from '../models/customer-affiliation.model';

@Component({
    selector: 'historical-customer-affiliation',
    templateUrl: './historical-customer-affiliation.html',
    inputs: ['customerNumberId']
})
export class HistoricalCustomerAffiliationComponent extends BaseComponent implements OnChanges {
    public affiliations: CustomerAffiliation[];
    public customerNumberId: number;

    private affiliationTypes: CustomerAffiliationType = new CustomerAffiliationType();

    constructor(private customerService: CustomerManageService) {
        super();
    }

    ngOnInit() {
    }

    ngOnChanges() {
        if (this.affiliations !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumberId != null) {
            this.populateHistoricalAffiliations(this.customerNumberId);
        }
    }

    populateHistoricalAffiliations(customerNumberId: number) {
        var self = this;

        this.customerService.getHistoricalCustomerAffiliations(customerNumberId)
            .subscribe(result => {
                this.affiliations = result;
            },
            e => {
                this.affiliations = [];
                console.log('error', e);
            },
            () => {
                this.denormalizeData();
            });
    }

    denormalizeData() {
        for (const affiliate of this.affiliations) {
            affiliate.affiliateType = this.getValues(affiliate.customerAffiliationTypeId, this.affiliationTypes);
        }
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }
}
